import styled from "styled-components";
import headerImage from "../../../assets/images/banner-bg.svg";

export const Header = styled.header`
  /* ... */
`;

export const LogoSection = styled.div`
  background-image: url(${headerImage});
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 120px;
  background-position: bottom;
  position: relative;
  @media only screen (min-width: 768px) and (max-width: 1199px) {
    width: 90%;
    margin: 0 auto;
  }
  @media only screen and (max-width: 767px) {
    background-position: 100% center; /* Keeps the image centered on smaller screens */
  }
`;

export const LogoSectionImage = styled.div`
  display: flex;
  justify-content: center; /* Centers the content horizontally */
  align-items: center; /* Centers the content vertically */
  padding: 2rem; /* Use smaller, consistent padding */
  box-sizing: border-box; /* Ensures padding is included in width/height calculations */
  width: 100%; /* Make the container responsive */

  @media only screen and (min-width: 768px) and (max-width: 1440px) {
    padding: 1.5rem; /* Adjust padding for medium screens */
    margin-left: auto; /* Center the container */
    margin-right: auto;
  }

  @media only screen and (max-width: 767px) {
    padding: 1rem; /* Reduce padding for smaller screens */
    margin-left: auto; /* Center the container */
    margin-right: auto;
  }
`;
